export const getProductAndFallbackId = (
  akl: string | string[] | undefined,
  sku: string | string[] | undefined,
) => {
  const aklString = Array.isArray(akl) ? akl[akl.length - 1] : akl;
  const skuString = Array.isArray(sku) ? sku[sku.length - 1] : sku;
  return { productId: skuString || aklString || '', fallbackId: aklString || '' };
};
